import { Component } from '@angular/core';
import { NavController } from '@ionic/angular';
import { CoreProvider } from 'src/app/services/core';

@Component({
  selector: 'app-error',
  styleUrls: ['error.scss'],
  templateUrl: 'error.html'
})
export class ErrorComponent {
  
  constructor(private _navCtrl: NavController, private core: CoreProvider) { }

  logout() {
    this.core.auth.logout();
    // this.core.setRoot(LoginPage, {noautologin: true});
  }

}
